import React, { useEffect, useRef, useState } from "react";
import "./Strength.css";
import SideModalOne from "../SideModalOne/SideModalOne";
import SideModalTwo from "../SideModalTwo/SideModalTwo";
import SideModalThree from "../SideModalThree/SideModalThree";
import SideModalFour from "../SideModalFour/SideModalFour";
import ResultPageLast from "../ResultPageLast/ResultPageLast";
import { END_URL, IMG_URL, ASSET_URL } from "../../config";
import axios from "axios";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

import { useParams } from "react-router-dom";
import vec from "../../images/Vector.svg";
import ww from "../../images/yellow-loc.svg";

import ll from "../../images/str-lock.png";
import l2 from "../../images/str-lock.png";

function Strength({
  resultRef,
  subs,
  Has,
  plan,
  ResultLast,
  onLoginChange,
  result,
  demension,
  token,
  subplan,
  testdata,
  subcribed,
  badge,
  userdetail,
  TestLink,
  handleSub,
  PopupContent,
  UnLockModal,
  setUnLockModal
}) {
  const { slug } = useParams();

  const modalRef = useRef(null);
  const [scale, setScale] = useState(0.8);
  const user = localStorage.getItem("user");
  const [testData, settestData] = useState(testdata);

  const [Opacity, setOpacity] = useState(subcribed);

  const LocalTest = JSON.parse(localStorage.getItem(slug));
  const [SavedTest, setSavedTest] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);

  const [LockModal, setLockModal] = useState(false);

  useEffect(() => {
    console.log("subcribed changed:", subcribed);
  }, [subcribed]);

  
  useEffect(() => {
    if (UnLockModal) {
      setLockModal(true);
    }
  }, [UnLockModal]);
  
  const closeModal = () => {
    setLockModal(false);
    setUnLockModal(false);
  };

  useEffect(() => {
    if (user) {
      SaveTest();
    }

    // if(!user)
    // {
    //     setTimeout(() => {

    //         window.scrollTo({ top: 0, behavior: 'smooth' });
    //         onLoginChange(true);
    //     }, 5000);
    // }

    // checkingSubcription();

    settestData(testdata);
  }, [user, testData]);

  // const checkingSubcription = async () => {
  //   // Use LocalTest instead of testData if that's what ResultAll uses
  //   const dataToSend = LocalTest || testData;
  //   if (!dataToSend || !dataToSend.test || !dataToSend.test.id) {
  //     console.error("Missing required data");
  //     return;
  //   }
  //   try {
  //     const response = await axios.post(`${END_URL}/check-subcription`, dataToSend, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         'Content-Type': 'application/json'
  //       }
  //     });

  //     setOpacity(response.data.subcription > 0);

  //   } catch (error) {
  //     console.error("Error checking subscription:", error);
  //   }
  // };

  const SaveTest = async () => {
    try {
      const response = await axios.post(`${END_URL}/submit/test`, LocalTest, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const testsave = response.data.saved;

      setSavedTest(testsave);
    } catch (error) {
      console.error("Error sending result:", error);
    }
  };

  useEffect(() => {
    const parent = modalRef.current?.parentElement;
    if (!parent || !modalRef.current) return;

    const resizeObserver = new ResizeObserver(() => {
      const parentHeight = parent.clientHeight;
      const contentHeight = modalRef.current?.scrollHeight;

      const newScale =
        contentHeight > parentHeight ? parentHeight / contentHeight : 1;

      setScale(Math.min(newScale, 1));
    });

    resizeObserver.observe(parent);

    return () => resizeObserver.disconnect();
  }, [subcribed]);

  function groupBlurContent(data) {
    if (!data) {
      return 0;
    }

    const clssgrop = ["", "default", "db", "dc", "dd"];

    const result = [];
    let blurGroup = [];

    let blurGroupIndex = 0;

    for (let i = 0; i < data.length; i++) {
      const item = data[i];

      if (item.input_type === "blur_content") {
        blurGroup.push(item);
      } else if (
        blurGroup.length > 0 &&
        ["text_area", "image"].includes(item.input_type) &&
        ["popup_content", "popup_image"].includes(item.type)
      ) {
        blurGroup.push(item);
      } else {
        if (blurGroup.length > 0) {
          const classIndex = (blurGroupIndex % (clssgrop.length - 1)) + 1;

          result.push({
            type: "blur_group",
            input_type: "blur_content",
            items: blurGroup,
            clssgrop: clssgrop[classIndex],
          });
          blurGroup = [];

          blurGroupIndex++;
        }

        result.push(item);
      }
    }

    if (blurGroup.length > 0) {
      const classIndex = (blurGroupIndex % (clssgrop.length - 1)) + 1;

      result.push({
        type: "blur_group",
        input_type: "blur_content",
        items: blurGroup,
        clssgrop: clssgrop[classIndex],
      });
    }

    return result;
  }


  console.log(demension,'demension');

  const structuredContent = groupBlurContent(demension?.dimension_content);

  const groupedContent = [];
  let currentGroup = null;

  structuredContent.forEach((item) => {
    if (item.type === "heading") {

      if (currentGroup) groupedContent.push(currentGroup);
      currentGroup = { heading: item,call_action: null, items: [] };

    } 
    else {

      if (!currentGroup) {
        currentGroup = { heading: null,call_action: null, items: [] };
      }

      if (item.type === "call_action") {

        currentGroup.call_action = item;

      } else {

        currentGroup.items.push(item);

      }
    }
  });

  if (currentGroup) groupedContent.push(currentGroup);

    const HandleLockModal = () => {
      setLockModal(true);
    };

    const LoginShow = () => {
      onLoginChange(true);
    };

  
  return (
    <>
      {/* {!Opacity && ( */}
        <div className="strg-main da">
          {groupedContent.map((group, groupIndex) => {
            const sideMenuItem = result?.find((item) => {
              if (!group.heading?.value) return false;
              const titleMatch = item.title
                .toLowerCase()
                .includes(
                  group.heading.value.toLowerCase().replace(/^[a-z]\.\s*/i, ""),
                );
              return titleMatch;
            });

            return (
              <div className="strg-group strg-sub-main" key={groupIndex}>
                {group.heading && (
                  <div
                    className="strg-one"
                    data-id={group.heading.value
                      .toLowerCase()
                      .replace(/\s+/g, "-")
                      .replace(/[^\w-]/g, "")}
                    data-section-id={
                      sideMenuItem?.id ||
                      group.heading.value
                        .toLowerCase()
                        .replace(/\s+/g, "-")
                        .replace(/[^\w-]/g, "")
                    }
                    data-numeric-id={sideMenuItem?.id}
                  >
                    <h2>{group.heading.value || ""}</h2>
                  </div>
                )}

                {group.items.map((item, index) => (
                  <div ref={(el) => resultRef.current[index]} key={index}>
                    {item.type === "text_content" && (
                      <div className={`strg-one ${item.input_type}`}>
                        <div dangerouslySetInnerHTML={{ __html: item.value }} />
                      </div>
                    )}
                    {item.type === "blur_group" && (
                      <div className="strg-one">

                        {/* {item.items.find((i) => i.type === "blur_content") && (
                          <div
                            className="test"
                            dangerouslySetInnerHTML={{
                              __html:
                                item.items.find(
                                  (i) => i.type === "blur_content",
                                )?.value || "",
                            }}
                          />
                        )} */}

                        {/* <div
                          className="strg-modal"
                          style={{ backdropFilter: "blur(3px)" }}
                        >
                          {item.items.find((i) => i.type === "popup_image") &&
                            item.items.find(
                              (i) => i.type === "popup_content",
                            ) && (
                              <div
                                ref={modalRef}
                                className="modal-scale-wrapper"
                                style={{ transformOrigin: "center center" }}
                              >
                                <SideModalOne
                                  img={
                                    item.items.find(
                                      (i) => i.type === "popup_image",
                                    )?.value
                                  }
                                  detail={
                                    item.items.find(
                                      (i) => i.type === "popup_content",
                                    )?.value
                                  }
                                  Hasi={Has}
                                  plan={plan}
                                  onLoginChange={onLoginChange}
                                  token={token}
                                  subplan={subplan}
                                  testdata={testdata}
                                  clssgrop={item.clssgrop}
                                  userdetail={userdetail}
                                  TestLink={TestLink}
                                  free_test_sub_modal={
                                    demension?.free_test_sub_modal
                                  }
                                />
                              </div>
                            )}
                        </div> */}

                        <div className="strg-one-new-pop"   style={{
                            backgroundImage: `url(${IMG_URL}/d0/${
                              item.items.find((i) => i.type === "popup_image")?.value
                            })`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                          }} >

                          <div className="strg-one-new-pop-inner">

                            <div className="strg-one-new-pop-1 pop-boxh2" dangerouslySetInnerHTML={{__html: item.items.find((i) => i.type === "popup_content",)?.value }} />

                            <div className="strg-one-new-pop-box">

                              <span  dangerouslySetInnerHTML={{__html: item.items.find((i) => i.type === "blur_content",)?.value }} />

                                {token ? (
                                    <a class="continue-btn new-commom-btn" 
    
                                              onClick={() => handleSub(demension?.free_test_sub_modal)}

                                              style={{
                                                  '--blur_button_color':item.items.find((i) => i.type === "blur_button",)?.value,
                                                  '--blur_button_color_hover':item.items.find((i) => i.type === "blur_button_hover",)?.value,
                                                   '--luminus_button_color_15': `color-mix(in srgb, ${item.items.find((i) => i.type === "blur_button",)?.value} 15%, white)`,
                                                  '--luminus_button_color_25': `color-mix(in srgb, ${item.items.find((i) => i.type === "blur_button",)?.value} 25%, white)`,
                                                  '--luminus_button_color_38': `color-mix(in srgb, ${item.items.find((i) => i.type === "blur_button",)?.value} 38%, white)`,
                                                  '--luminus_button_color_45': `color-mix(in srgb, ${item.items.find((i) => i.type === "blur_button",)?.value} 45%, white)`,
                                                  '--luminus_button_color_50': `color-mix(in srgb, ${item.items.find((i) => i.type === "blur_button",)?.value} 50%, white)`,
                                                  '--luminus_button_color_55': `color-mix(in srgb, ${item.items.find((i) => i.type === "blur_button",)?.value} 55%, white)`,
                                                  '--luminus_button_color_70': `color-mix(in srgb, ${item.items.find((i) => i.type === "blur_button",)?.value} 70%, white)`,
                                                  '--luminus_button_color_85': `color-mix(in srgb, ${item.items.find((i) => i.type === "blur_button",)?.value} 85%, white)`,
                                                  '--luminus_button_color_92': `color-mix(in srgb, ${item.items.find((i) => i.type === "blur_button",)?.value} 92%, white)`,
                                                  '--luminus_button_color_100': item.items.find((i) => i.type === "blur_button",)?.value,
                                                }}
                                      >
                                      <div>
                                        <img src={ww} alt="" />
                                      </div>

                                      <span>{PopupContent?.result_page_unlock_button}</span>

                                      <span class="righ-arr">
                                        <FontAwesomeIcon icon={faArrowRight} />
                                      </span>
                                    </a>
                                ):(

                                   <a class="continue-btn new-commom-btn" 
                                           
                                             onClick={() => LoginShow()}
                                             style={{'--blur_button_color':item.items.find((i) => i.type === "blur_button",)?.value,
                                                    '--blur_button_color_hover':item.items.find((i) => i.type === "blur_button_hover",)?.value,
                                                    '--luminus_button_color_15': `color-mix(in srgb, ${item.items.find((i) => i.type === "blur_button",)?.value} 15%, white)`,
                                                    '--luminus_button_color_25': `color-mix(in srgb, ${item.items.find((i) => i.type === "blur_button",)?.value} 25%, white)`,
                                                    '--luminus_button_color_38': `color-mix(in srgb, ${item.items.find((i) => i.type === "blur_button",)?.value} 38%, white)`,
                                                    '--luminus_button_color_45': `color-mix(in srgb, ${item.items.find((i) => i.type === "blur_button",)?.value} 45%, white)`,
                                                    '--luminus_button_color_50': `color-mix(in srgb, ${item.items.find((i) => i.type === "blur_button",)?.value} 50%, white)`,
                                                    '--luminus_button_color_55': `color-mix(in srgb, ${item.items.find((i) => i.type === "blur_button",)?.value} 55%, white)`,
                                                    '--luminus_button_color_70': `color-mix(in srgb, ${item.items.find((i) => i.type === "blur_button",)?.value} 70%, white)`,
                                                    '--luminus_button_color_85': `color-mix(in srgb, ${item.items.find((i) => i.type === "blur_button",)?.value} 85%, white)`,
                                                    '--luminus_button_color_92': `color-mix(in srgb, ${item.items.find((i) => i.type === "blur_button",)?.value} 92%, white)`,
                                                    '--luminus_button_color_100': item.items.find((i) => i.type === "blur_button",)?.value,
                                             }}
                                              
                                      >
                                      <div>
                                        <img src={ww} alt="" />
                                      </div>

                                      <span>{PopupContent?.result_page_unlock_button}</span>

                                      <span class="righ-arr">
                                        <FontAwesomeIcon icon={faArrowRight} />
                                      </span>
                                    </a>

                                )}

                                {item.items.find((i) => i.type === "popup_footer",)?.value && (

                                  <div className="last-strg-text" dangerouslySetInnerHTML={{__html:item.items.find((i) => i.type === "popup_footer",)?.value}}/>
                                   
                                )}

                            </div>
                          </div>
                        </div>

                      </div>
                    )}
                  </div>
                ))}

                 {group.call_action && (
                    
                        <a class="continue-btn new-commom-btn call-action-btn" 
                                    data-id={group.call_action.value
                                      .toLowerCase()
                                      .replace(/\s+/g, "-")
                                      .replace(/[^\w-]/g, "")}
                                    data-section-id={
                                      sideMenuItem?.id ||
                                      group.call_action.value
                                        .toLowerCase()
                                        .replace(/\s+/g, "-")
                                        .replace(/[^\w-]/g, "")
                                    }
                                    data-numeric-id={sideMenuItem?.id}

                                  style={{'--call_action_button_color':demension?.dimension_color?.call_action_button_color,
                                          '--call_action_button_color_hover':demension?.dimension_color?.call_action_button_color_hover,
                                          '--luminus_button_color_15': `color-mix(in srgb, ${demension?.dimension_color?.call_action_button_color_hover} 15%, white)`,
                                          '--luminus_button_color_25': `color-mix(in srgb, ${demension?.dimension_color?.call_action_button_color_hover} 25%, white)`,
                                          '--luminus_button_color_38': `color-mix(in srgb, ${demension?.dimension_color?.call_action_button_color_hover} 38%, white)`,
                                          '--luminus_button_color_45': `color-mix(in srgb, ${demension?.dimension_color?.call_action_button_color_hover} 45%, white)`,
                                          '--luminus_button_color_50': `color-mix(in srgb, ${demension?.dimension_color?.call_action_button_color_hover} 50%, white)`,
                                          '--luminus_button_color_55': `color-mix(in srgb, ${demension?.dimension_color?.call_action_button_color_hover} 55%, white)`,
                                          '--luminus_button_color_70': `color-mix(in srgb, ${demension?.dimension_color?.call_action_button_color_hover} 70%, white)`,
                                          '--luminus_button_color_85': `color-mix(in srgb, ${demension?.dimension_color?.call_action_button_color_hover} 85%, white)`,
                                          '--luminus_button_color_92': `color-mix(in srgb, ${demension?.dimension_color?.call_action_button_color_hover} 92%, white)`,
                                          '--luminus_button_color_100': demension?.dimension_color?.call_action_button_color_hover,
                                        }}

                                  onClick={() => handleSub(demension?.free_test_sub_modal)}
                                  
                          >
                          <span>{group.call_action.value || ""}</span>

                          <span class="righ-arr">
                            <FontAwesomeIcon icon={faArrowRight} />
                          </span>
                        </a>

                )}

              </div>
            );
          })}
        </div>
      {/* )} */}

      {LockModal && (
            <div className={`newdashpop-overlay lock-dashboard`}>
              <div className="newdashpop-inner">
                <div className="newdashpop-container">
                  <button
                    className="newdashpop-close"
                    onClick={closeModal}
                  >
                    &times;
                  </button>

                  <div className="conent-pop lock-dashboard-content">
                    <div className="dash-loc-title">
                      <span>
                        <img src={ww} alt="" />
                      </span>{" "}
                      <h3>{PopupContent?.trait_unlock_title}</h3>
                    </div>
 
                    <div className="dash-lock-icons"dangerouslySetInnerHTML={{__html:PopupContent?.trait_unlock_pattern}} />


                  {token ? (

                      <a className="home-slider-sun-box-a" onClick={() => handleSub(demension?.free_test_sub_modal)} 
                      
                        style={{'--full_trait_button_color':demension?.dimension_color?.full_trait_button_color,
                              '--full_trait_button_color_hover':demension?.dimension_color?.full_trait_button_color_hover,
                              '--luminus_button_color_15': `color-mix(in srgb, ${demension?.dimension_color?.full_trait_button_color} 15%, white)`,
                              '--luminus_button_color_25': `color-mix(in srgb, ${demension?.dimension_color?.full_trait_button_color} 25%, white)`,
                              '--luminus_button_color_38': `color-mix(in srgb, ${demension?.dimension_color?.full_trait_button_color} 38%, white)`,
                              '--luminus_button_color_45': `color-mix(in srgb, ${demension?.dimension_color?.full_trait_button_color} 45%, white)`,
                              '--luminus_button_color_50': `color-mix(in srgb, ${demension?.dimension_color?.full_trait_button_color} 50%, white)`,
                              '--luminus_button_color_55': `color-mix(in srgb, ${demension?.dimension_color?.full_trait_button_color} 55%, white)`,
                              '--luminus_button_color_70': `color-mix(in srgb, ${demension?.dimension_color?.full_trait_button_color} 70%, white)`,
                              '--luminus_button_color_85': `color-mix(in srgb, ${demension?.dimension_color?.full_trait_button_color} 85%, white)`,
                              '--luminus_button_color_92': `color-mix(in srgb, ${demension?.dimension_color?.full_trait_button_color} 92%, white)`,
                              '--luminus_button_color_100': demension?.dimension_color?.full_trait_button_color,
                            }}
                      >

                        <span className="home-slider-sun-box-a-text">

                             {PopupContent?.trait_unlock_button_label}
                        </span>

                        <span className="home-slider-sun-box-a-icon img-icon">
                         
                          <img src={ww} alt="" />

                        </span>

                      </a>

                      ) : (

                        <a className="home-slider-sun-box-a"  onClick={() => LoginShow()}
                        
                          style={{'--full_trait_button_color':demension?.dimension_color?.full_trait_button_color,
                                  '--full_trait_button_color_hover':demension?.dimension_color?.full_trait_button_color_hover,
                                  '--luminus_button_color_15': `color-mix(in srgb, ${demension?.dimension_color?.full_trait_button_color} 15%, white)`,
                                  '--luminus_button_color_25': `color-mix(in srgb, ${demension?.dimension_color?.full_trait_button_color} 25%, white)`,
                                  '--luminus_button_color_38': `color-mix(in srgb, ${demension?.dimension_color?.full_trait_button_color} 38%, white)`,
                                  '--luminus_button_color_45': `color-mix(in srgb, ${demension?.dimension_color?.full_trait_button_color} 45%, white)`,
                                  '--luminus_button_color_50': `color-mix(in srgb, ${demension?.dimension_color?.full_trait_button_color} 50%, white)`,
                                  '--luminus_button_color_55': `color-mix(in srgb, ${demension?.dimension_color?.full_trait_button_color} 55%, white)`,
                                  '--luminus_button_color_70': `color-mix(in srgb, ${demension?.dimension_color?.full_trait_button_color} 70%, white)`,
                                  '--luminus_button_color_85': `color-mix(in srgb, ${demension?.dimension_color?.full_trait_button_color} 85%, white)`,
                                  '--luminus_button_color_92': `color-mix(in srgb, ${demension?.dimension_color?.full_trait_button_color} 92%, white)`,
                                  '--luminus_button_color_100': demension?.dimension_color?.full_trait_button_color,
                                }}
                        >

                          <span className="home-slider-sun-box-a-text">

                              {PopupContent?.trait_unlock_button_label}
                          </span>

                          <span className="home-slider-sun-box-a-icon img-icon">
                          
                            <img src={ww} alt="" />

                          </span>

                        </a>

                      )}

                      <span> {PopupContent?.trait_unlock_bottom}</span>

                  </div>
                </div>
              </div>
            </div>
          )}

    </>
  );
}

export default Strength;
